import { render, staticRenderFns } from "./Reunload.vue?vue&type=template&id=08b0053c&scoped=true"
import script from "./Reunload.vue?vue&type=script&lang=js"
export * from "./Reunload.vue?vue&type=script&lang=js"
import style0 from "./Reunload.vue?vue&type=style&index=0&id=08b0053c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0053c",
  null
  
)

export default component.exports